/* Wrapper layout for the GridGroup offers tab. Previously borrowed from the OFFERS_WIDGET's
   Offers.module.css while both lived in apps/atlas; that widget moved to
   @cx-web/components/page-template/OffersWidget (NGF-6520 A3, a separate build unit), so this
   atlas-side renderer keeps its own copy of the wrapper classes. */
.grid {
  max-width: 1440px;
  padding: 6px 0;
  width: 100%;
}

.offersTab {
  margin: 16px auto;
  max-width: 1440px;
}

.sportsLandingPage,
.card {
  margin: 16px auto;
  padding: 0 22px;
  width: 100%;
  max-width: 1440px;
}

/* 1440px + 16px */
@media (max-width: 1472px) {
  .sportsLandingPage,
  .card {
    overflow-x: hidden;
  }
}
